import { render } from "./ProfileSettings.vue?vue&type=template&id=5b9c062b"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/ProfileSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9c062b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9c062b', __exports__)) {
    api.reload('5b9c062b', __exports__)
  }
  
  module.hot.accept("./ProfileSettings.vue?vue&type=template&id=5b9c062b", () => {
    api.rerender('5b9c062b', render)
  })

}


export default __exports__